import { vehiclesApi } from '@repo/api'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export const useTrucksPaginated = (params: {
  page: number
  pageSize: number
  search?: string
}) => {
  return useQuery({
    queryKey: ['vehicles', 'trucks', 'paginated', params],
    queryFn: () => vehiclesApi.getTrucksPaginated(params),
    placeholderData: keepPreviousData,
  })
}
